export enum ReleaseStatus {
  Open = 'Open',
  InProgress = 'InProgress',
  Fulfilled = 'Fulfilled',
}
